<template>
  <main>
    <Header />
    <div id="layoutSidenav">
      <Sidebar/>
      <div id="layoutSidenav_content">
        <vue-page-transition name="fade-in-right">
          <router-view></router-view>
        </vue-page-transition>
        <Footer />
      </div>
    </div>
  </main>
</template>
<script>
import Header from "../layout/Header.vue";
import Sidebar from "../layout/Sidebar.vue";
import Footer from "../layout/Footer.vue";
export default {
  name: "system",
  components: {
    Header,
    Sidebar,
    Footer,
  },
};
</script>